module.exports = __webpack_public_path__ + "img/bank-3.c63d9103.jpg";